// Switches — the "browse by switch" picker grid + per-switch user list.
// JSON siblings of the legacy PHP api/switches.php / api/switch_users.php.
// Read-only GETs; any authenticated user. Live state (online/IP/rx_power)
// is merged from Redis on the Go side, so these are cheap to poll.

import type { ApiClient } from "./client.js";
import type { SwitchListResponse, SwitchUsersResponse } from "./types.js";

export function makeSwitchesApi(client: ApiClient) {
  return {
    /** All switches with their configured roster size + live online count. */
    list(): Promise<SwitchListResponse> {
      return client.get<SwitchListResponse>("/v1/api/switches/list");
    },
    /** The subscribers configured behind one switch, with live PPPoE state
     *  and the switch box's own ONU blob. */
    users(switchName: string): Promise<SwitchUsersResponse> {
      return client.get<SwitchUsersResponse>("/v1/api/switches/users", { switch: switchName });
    },
  };
}

export type SwitchesApi = ReturnType<typeof makeSwitchesApi>;
